<template>
  <div class="header">
    <div class="logo">
      <svg-icon :name="'logo'" :width="79" :height="60"></svg-icon>
    </div>
    <div class="menu" @click.stop="togglePhoneMenu()">
      <svg-icon :name="'menu'"></svg-icon>
    </div>
    <div class="logo-phone">
      <svg-icon :name="'logo'" :width="53" :height="40"></svg-icon>
    </div>
    <div class="actions">
      <div class="user-info">
        <avatar :avatar-name="username"></avatar>
        <div class="username" @click.stop="toggleProfilePopup()" tabindex="0" @keydown.enter.space.stop="toggleProfilePopup()" style="outline: none; cursor: pointer;">
          <span>{{ username }}</span>
          <svg-icon :name="'dropdown'" :width="12" :height="12"></svg-icon>
        </div>
        <transition name="fade">
          <div class="profile-popup" v-show="showProfile" @click.stop="SignOut" tabindex="0" @keydown.enter.space.stop="SignOut" style="outline: none; cursor: pointer;">
            <svg-icon :name="signOutTab.iconName"></svg-icon>
            <span class="sign-out">{{ signOutTab.label }}</span>
          </div>
        </transition>
      </div>
      <div class="language">
      </div>
    </div>
    <div class="current-tab-label" v-if="currentTab.label !== 'Home'">
      <svg-icon :name="`${currentTab.iconName}-active`"></svg-icon>
      <div class="dynamic-content" v-html="currentTab.label"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HomeHeader',
  data() {
    return {
      showProfile: false,
      signOutTab: {
        label: 'Sign Out',
        iconName: 'sign-out'
      }
    };
  },
  computed: {
    ...mapState({
      currentTab: state => state.currentTab,
      userInfo: state => state.userInfo
    }),
    username() {
      return `${this.userInfo.firstName} ${this.userInfo.lastName}`;
    }
  },
  methods: {
    toggleProfilePopup() {
      this.showProfile = !this.showProfile;
      if (this.showProfile) {
        this.$nextTick(() => {
          const popup = this.$el.querySelector('.profile-popup');
          if (popup && typeof popup.focus === 'function') {
            popup.focus();
          }
        });
      }
    },
    togglePhoneMenu() {
      this.$store.commit('SHOW_PHONE_MENU_CHANGED', true);
    },
    SignOut() {
      localStorage.setItem('authStatus', 'logout');
      window.location.href = '/lendingcircles/secur/logout.jsp';
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../sass/main.scss';

.fade-enter-active, .fade-leave-active {
  transition: all 200ms linear;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.header {
  position: fixed;
  z-index: 999;
  padding: 0 15px;
  height: $header-height;
  width: 100%;
  @include inline-flex-row;
  justify-content: space-between;
  align-items: center;
  background-color: $bg-color-white;
  box-shadow: 0 2px 4px rgba(188, 187, 187, 0.5);

  @media screen and (max-width: $max-width-phone) {
    height: $header-height-phone;
  }

  .logo {
    width: $header-height;

    @media screen and (max-width: $max-width-phone) {
      display: none;
    }
  }

  .menu {
    padding-right: 20px;
    height: inherit;
  }
  .menu, .logo-phone {
    display: none;

    @media screen and (max-width: $max-width-phone) {
      @include inline-flex-row;
      justify-content: center;
      align-items: center;
    }
  }

  .actions {
    height: inherit;
    width: auto;
    @include center-style;
    justify-content: space-between;

    @media screen and (max-width: $max-width-phone) {
      display: none;
    }

    .user-info {
      position: relative;
      padding: 0 30px;
      height: inherit;
      @include center-style;
      justify-content: space-between;
      font-size: $font-size-base;
      color: $tab-active;

      .username {
        height: inherit;
        @include center-style;

        &:hover {
          cursor: pointer;
        }
      }

      span {
        margin: 0 20px;
      }

      .sign-out {
        margin: unset !important;
      }
    }

    .profile-popup {
      padding: 20px;
      position: absolute;
      top: $header-height;
      right: 0;
      background-color: $bg-color-white;
      box-shadow: 0 2px 4px rgba(188, 187, 187, 0.5);
      transition: transform 200ms linear;

      .icon {
        margin-right: 15px;
      }

      &:hover {
        cursor: pointer;
      }
    }

    .language {
      padding: 0 50px;
      height: inherit;
      border-left: 2px solid $border-color-header;
      width: 259px;
      @include center-style;
    }
  }

  .current-tab-label {
    position: absolute;
    z-index: 999;
    display: none;
    top: $header-height;
    left: 0;
    right: 0;
    height: 40px;
    background-color: $tab-active;
    color: $font-color-white;

    .icon {
      margin-right: 10px;
    }

    @media screen and (max-width: $max-width-phone) {
      top: $header-height-phone;
      @include inline-flex-row;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-layout/HomeHeader.vue